import React from 'react';
import Footer from '../Footer/Footer';
import './InfoPage.css';

const serviceLinks = [
    ['/about', 'О MERKULS'],
    ['/help/how-to-order', 'Как оформить заказ'],
    ['/help/delivery', 'Доставка и таможня'],
    ['/help/payment', 'Оплата и комиссия'],
    ['/help/returns', 'Возврат и претензии'],
    ['/help/authenticity', 'Проверка подлинности'],
    ['/help/faq', 'Частые вопросы'],
    ['/legal/sale-terms', 'Условия продажи'],
    ['/legal/privacy', 'Конфиденциальность'],
];

const AboutPage = ({ data }) => (
    <>
        <main className="about-editorial">
            <section className="about-editorial__hero">
                <img src="/img/home/merkuls-editorial-detail.png" alt="Редакционная подборка MERKULS" />
                <div className="about-editorial__shade" />
                <div className="about-editorial__hero-copy">
                    <p>О MERKULS</p>
                    <h1>В поиске<br />точного выбора</h1>
                    <span>Кураторский каталог</span>
                </div>
            </section>

            <section className="about-editorial__statement">
                <p>{data?.Summary}</p>
            </section>

            <section className="about-editorial__story">
                <div className="about-editorial__story-copy">
                    <p className="about-editorial__kicker">Наш подход</p>
                    {(data?.Sections?.$values || []).map((section, index) => (
                        <div className="about-editorial__chapter" key={section.Title}>
                            <span>{String(index + 1).padStart(2, '0')}</span>
                            <div>
                                <h2>{section.Title}</h2>
                                {(section?.Paragraphs?.$values || []).map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                                {(section?.Items?.$values || []).length > 0 && (
                                    <ul>{section.Items.$values.map((item) => <li key={item}>{item}</li>)}</ul>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="about-editorial__media">
                    <img src="/img/home/merkuls-accessories-editorial.png" alt="Детали коллекции MERKULS" loading="lazy" />
                </div>
            </section>

            <section className="about-editorial__closing">
                <p>Вещи, которые остаются актуальными дольше одного сезона.</p>
                <a href="/shopping/women/items">Смотреть коллекцию</a>
            </section>
        </main>
        <Footer />
    </>
);

const InfoPage = ({ data }) => {
    const pathname = typeof window !== 'undefined' ? window.location.pathname.toLowerCase() : '';

    if (pathname === '/about') {
        return <AboutPage data={data} />;
    }

    return (
        <>
            <main className="info-page">
                <header className="info-page__hero">
                    <div className="info-page__eyebrow">Клиентский сервис</div>
                    <h1 className="info-page__title">{data?.Title}</h1>
                    {data?.Summary && <p className="info-page__summary">{data.Summary}</p>}
                </header>

                <div className="info-page__layout">
                    <aside className="info-page__aside" aria-label="Разделы клиентского сервиса">
                        <p className="info-page__aside-title">Помощь и информация</p>
                        <nav className="info-page__nav">
                            {serviceLinks.map(([url, label]) => (
                                <a href={url} className={pathname === url.toLowerCase() ? 'is-active' : ''} aria-current={pathname === url.toLowerCase() ? 'page' : undefined} key={url}>
                                    {label}
                                </a>
                            ))}
                        </nav>

                        <div className="info-page__contact">
                            <p className="info-page__contact-label">Поддержка</p>
                            <strong>Ежедневно, 09:00–21:00</strong>
                            <a href="mailto:support@merkuls.com">support@merkuls.com</a>
                            <a href="tel:+74951234567">+7 495 123-45-67</a>
                        </div>
                    </aside>

                    <article className="info-page__content">
                        {(data?.Sections?.$values || []).map((section, sectionIndex) => (
                            <section className="info-page__section" key={section.Title}>
                                <div className="info-page__section-number">{String(sectionIndex + 1).padStart(2, '0')}</div>
                                <div className="info-page__section-body">
                                    <h2>{section.Title}</h2>
                                    {(section?.Paragraphs?.$values || []).map((paragraph, index) => (
                                        <p key={index}>{paragraph}</p>
                                    ))}
                                    {(section?.Items?.$values || []).length > 0 && (
                                        <ol>
                                            {section.Items.$values.map((item) => <li key={item}>{item}</li>)}
                                        </ol>
                                    )}
                                </div>
                            </section>
                        ))}
                    </article>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default InfoPage;
